import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#040404] flex items-center justify-center px-6 relative overflow-hidden">
      {/* 🔥 Background glow (red dominant) */}
      <motion.div
        className="absolute w-[600px] h-[600px] bg-red-500/10 rounded-full blur-[140px]"
        animate={{ x: [0, 40, -30, 0], y: [0, -30, 30, 0] }}
        transition={{ duration: 12, repeat: Infinity }}
      />

      <motion.div
        className="absolute w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-[120px] right-0 bottom-0"
        animate={{ x: [0, -30, 30, 0], y: [0, 30, -30, 0] }}
        transition={{ duration: 14, repeat: Infinity }}
      />

      {/* 🔥 Card */}
      <motion.div
        initial={{ opacity: 0, y: 60, scale: 0.94 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="relative w-full max-w-xl rounded-3xl bg-white/[0.04] border border-white/10 backdrop-blur-2xl p-12 text-center shadow-[0_50px_140px_rgba(0,0,0,0.95)]"
      >
        {/* Gradient border */}
        <div className="absolute inset-0 rounded-3xl p-[1px] opacity-70" />

        {/* 🔥 Lottie Animation */}
        <motion.div
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="flex justify-center mb-6"
        >
          <div className="w-36 h-36 relative">
            {/* glow behind animation */}
            <div className="absolute inset-0 bg-red-500/20 blur-2xl rounded-full" />

            <iframe
              src="https://lottie.host/embed/b66e4cf6-be47-41d5-8953-747596bed1a1/EcE3vkXwup.lottie"
              className="w-full h-full relative z-10 rounded-xl"
              frameBorder="0"
            ></iframe>
          </div>
        </motion.div>

        {/* 🔥 Title */}
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-3xl font-semibold text-white mb-2 tracking-wide"
        >
          Kitchen Restricted 🔥
        </motion.h1>

        {/* 🔥 Subtitle */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-gray-400 text-sm mb-8 leading-relaxed"
        >
          This section is off-limits — like a high heat cooking zone.
          <br />
          You’ll need elevated permissions to enter here.
        </motion.p>

        {/* 🔥 Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex justify-center gap-4"
        >
          <button
            onClick={() => navigate("/admindashboard")}
            className="
              relative px-6 py-2.5 rounded-xl text-sm font-medium
              bg-gradient-to-r from-red-500 to-amber-400 text-black
              hover:scale-105
              shadow-[0_10px_30px_rgba(239,68,68,0.4)]
              transition-all duration-200
            "
          >
            Go Dashboard
          </button>

          <button
            onClick={() => window.history.back()}
            className="
              px-6 py-2.5 rounded-xl text-sm
              border border-white/20
              text-gray-300
              hover:bg-white/10 hover:text-white
              hover:scale-105
              transition-all duration-200
            "
          >
            Go Back
          </button>
        </motion.div>

        {/* 🔥 Footer */}
        <p className="mt-10 text-xs text-gray-500 tracking-wider">
          ERROR 403 • HIGH HEAT ZONE LOCKED
        </p>
      </motion.div>
    </div>
  );
};

export default Unauthorized;
